import { checkExecutionStatus, createRequest } from "@/components/common/helpers/RequestHelpers";
import { addDays, format } from "date-fns";
import _ from "lodash";
import { NotificationManager } from "react-notifications";
import { v4 as uuidv4 } from "uuid";
import apiURL from "./apiURL";
import { Actions as LEAVEACTIONS } from "./leaveActions";
import { Actions as FSSREPORT_ACTIONS } from "./fssReportActions";
import pDebounce from "p-debounce";
// const apiURL = "http://localhost:3001";

// const orgId = window.location.pathname == '/xero/callback/' ? window.localStorage.getItem('organisation') : window.location.pathname.split('/')[2];
const settingsRequest = createRequest({
	urlPath: "/settings",
	 // local: true,
});

const sepaRequest = createRequest({
	urlPath: "/sepa",
});

// types of action
const Types = {
	PAYROLL_GET_EMPLOYEES: "PAYROLL_GET_EMPLOYEES",
	PAYROLL_TOGGLE_EMPLOYEE_EXPAND: "PAYROLL_TOGGLE_EMPLOYEE_EXPAND",
	PAYROLL_UPDATE_ALLOWANCE: "PAYROLL_UPDATE_ALLOWANCE",
	PAYROLL_SAVE_PAYSLIP: "PAYROLL_SAVE_PAYSLIP",
	PAYROLL_GENERATING_PAYSLIP: "PAYROLL_GENERATING_PAYSLIP",
	PAYROLL_ERROR_PAYSLIP: "PAYROLL_ERROR_PAYSLIP",
	PAYROLL_SAVED_ALL_PAYSLIP: "PAYROLL_SAVED_ALL_PAYSLIP",
	PAYROLL_SAVING_ALL_PAYSLIP: "PAYROLL_SAVING_ALL_PAYSLIP",
	PAYROLL_PAGE_TOGGLE: "PAYROLL_PAGE_TOGGLE",
	PAYROLL_DEPARTMENT_EXPAND: "PAYROLL_DEPARTMENT_EXPAND",
	PAYROLL_UPDATING_PAY_PERIOD: "PAYROLL_UPDATING_PAY_PERIOD",
	PAYROLL_PAY_PERIOD: "PAYROLL_PAY_PERIOD",
	PAYROLL_LAST_PAY_PERIOD: "PAYROLL_LAST_PAY_PERIOD",
	PAYROLL_UNPROCESS_TIMESHEETS_MODAL: "PAYROLL_UNPROCESS_TIMESHEETS_MODAL",
	PAYROLL_UNPROCESS_LOADING: "PAYROLL_UNPROCESS_LOADING",
	PAYROLL_UNPROCESS_COMPLETED: "PAYROLL_UNPROCESS_COMPLETED",
	PAYROLL_PAY_TERMINATED_MODAL: "PAYROLL_PAY_TERMINATED_MODAL",
	PAYROLL_PAY_TERMINATED_LOADING: "PAYROLL_PAY_TERMINATED_LOADING",
	PAYROLL_CREATE_TERMINATED_PAYSLIP: "PAYROLL_CREATE_TERMINATED_PAYSLIP",
	PAYROLL_PROCESS_TIMESHEETS_START: "PAYROLL_PROCESS_TIMESHEETS_START",
	PAYROLL_PROCESS_TIMESHEETS_COMPLETE: "PAYROLL_PROCESS_TIMESHEETS_COMPLETE",
	PAYROLL_PROCESS_TIMESHEETS_CLEAR: "PAYROLL_PROCESS_TIMESHEETS_CLEAR",
	PAYROLL_REMOVE_ALLOWANCE: "PAYROLL_REMOVE_ALLOWANCE",
	PAYROLL_TOGGLE_TAXABLE_WEEK: "PAYROLL_TOGGLE_TAXABLE_WEEK",
	PAYROLL_GENERATING_REPORTS: "PAYROLL_GENERATING_REPORTS",
	PAYROLL_REOPEN_MODAL: "PAYROLL_REOPEN_MODAL",
	PAYROLL_PREVIEW_PAYSLIP: "PAYROLL_PREVIEW_PAYSLIP",
	PAYROLL_GETTING_LIST: "PAYROLL_GETTING_LIST",
	PAYROLL_UPDATE_ID: "PAYROLL_UPDATE_ID",
	PAYROLL_CLEAR_PAYSLIP_MODAL: "PAYROLL_CLEAR_PAYSLIP_MODAL",
	PAYROLL_CLEARING_PAYSLIP: "PAYROLL_CLEARING_PAYSLIP",
	PAYROLL_CLEARED_PAYSLIP: "PAYROLL_CLEARED_PAYSLIP",
	PAYROLL_RTI_GENERATING: "PAYROLL_RTI_GENERATING",
	PAYROLL_RTI_GENERATING: "PAYROLL_RTI_GENERATING",
	PAYROLL_NOTE: "PAYROLL_NOTE",
	PAYROLL_CHANGE_PERIOD_START: "PAYROLL_CHANGE_PERIOD_START",
	PAYROLL_TEST_IN_LIVE_MODAL: "PAYROLL_TEST_IN_LIVE_MODAL",
	PAYROLL_TEST_CONFIRMATION_MODAL: "PAYROLL_TEST_CONFIRMATION_MODAL",
	PAYROLL_CLEAR_STATE: "PAYROLL_CLEAR_STATE",
	PAYROLL_UNSAVED_CHANGES_MODAL: "PAYROLL_UNSAVED_CHANGES_MODAL",
	PAYROLL_HOLIDAY_PAY_MODAL: "PAYROLL_HOLIDAY_PAY_MODAL",
	PAYROLL_HOLIDAY_PAY_WEEKS: "PAYROLL_HOLIDAY_PAY_WEEKS",
	PAYROLL_UPLOAD_ALLOWANCE_MODAL: "PAYROLL_UPLOAD_ALLOWANCE_MODAL",
	PAYROLL_APPROVAL_OPEN_MODAL: "PAYROLL_APPROVAL_OPEN_MODAL",
	PAYROLL_UPDATE_CHECKLIST_TOGGLE: "PAYROLL_UPDATE_CHECKLIST_TOGGLE",
	PAYROLL_SET_LATE_SUBMIT_MODAL: "PAYROLL_SET_LATE_SUBMIT_MODAL",
};

const payrollPageToggle = (page) => ({
	type: Types.PAYROLL_PAGE_TOGGLE,
	page,
});

const setReopenPayrollModalOpen = (open) => ({
	type: Types.PAYROLL_REOPEN_MODAL,
	open,
});

const setPayrollDepartmentExpanded = (department, expand) => ({
	type: Types.PAYROLL_DEPARTMENT_EXPAND,
	department,
	expand,
});

const payrollUpdateAllowance = (input) => ({
	type: Types.PAYROLL_UPDATE_ALLOWANCE,
	input,
});

const payrollRemoveAllowance = (input) => ({
	type: Types.PAYROLL_REMOVE_ALLOWANCE,
	input,
});

const payrollToggleEmployeeExpand = (employeeID) => ({
	type: Types.PAYROLL_TOGGLE_EMPLOYEE_EXPAND,
	employeeID,
});

const payrollUpdateList = (response) => ({
	type: Types.PAYROLL_GET_EMPLOYEES,
	payload: response,
});

const payrollSavePayslip = (response, ready, agreement) => ({
	type: Types.PAYROLL_SAVE_PAYSLIP,
	payload: response,
	ready,
	agreement,
});

const payrollGeneratingPayslip = (agreementID) => ({
	type: Types.PAYROLL_GENERATING_PAYSLIP,
	agreementID,
});

const payrollUpdateNote = ({ employeeID, note, toAdvisor }) => ({
	type: Types.PAYROLL_NOTE,
	employeeID,
	note,
	toAdvisor,
});

const payrollErrorPayslip = (agreementID) => ({
	type: Types.PAYROLL_ERROR_PAYSLIP,
	agreementID,
});

const payrollSavingAllPayslips = (department) => ({
	type: Types.PAYROLL_SAVING_ALL_PAYSLIP,
	department,
});

const getLastPayPeriod = (payPeriod) => ({
	type: Types.PAYROLL_LAST_PAY_PERIOD,
	payPeriod,
});

const toggleHolidayPayModal = ({ status, allowance, agreementId }) => ({
	type: Types.PAYROLL_HOLIDAY_PAY_MODAL,
	status,
	allowance,
	agreementId,
});

const uploadAllowanceModal = (status) => ({
	type: Types.PAYROLL_UPLOAD_ALLOWANCE_MODAL,
	status,
});

const weeklyPayData = (weeklyPay) => ({
	type: Types.PAYROLL_HOLIDAY_PAY_WEEKS,
	weeklyPay,
});

const getHolidayPay = (agreementId) => {
	return async (dispatch, getState) => {
		if (!agreementId) return;
		const state = getState();
		const { payPeriodDetails } = state.payroll || {};
		const { periodStart } = payPeriodDetails || {};

		await settingsRequest({
			method: "GET",
			path: `/payroll/weeklyPay/${agreementId}`,
			query: {
				periodStart,
			},
		}).then(({ data }) => {
			dispatch(weeklyPayData(data));
		});
	};
};

const payrollGetLastPayPeriod = () => {
	return (dispatch, getState) => {
		fetch(apiURL + `/settings/lastPayPeriod`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				console.log("last pay period", data);
				dispatch(getLastPayPeriod(data));
			});
	};
};

const getPayPeriod = (payload) => ({
	type: Types.PAYROLL_PAY_PERIOD,
	payload,
});

const updatingPayPeriod = () => ({
	type: Types.PAYROLL_UPDATING_PAY_PERIOD,
});

const getPayPeriodDetails = (id) => {
	return (dispatch, getState) => {
		settingsRequest({
			method: "GET",
			path: `/payPeriods/${id}`,
		}).then(({ data }) => {
			dispatch(loadPayPeriod(data));
		});
	};
};

const updatePayPeriodStatus = (id, status) => {
	return (dispatch, getState) => {
		settingsRequest({
			method: "POST",
			path: `/payPeriods/${id}/status`,
			body: { status },
		})
			.then(({ data }) => {
				dispatch(loadPayPeriod(data));
			})
			.catch((err) => {
				console.log("error", err);
				NotificationManager.error("Error Updating Pay Period Status", `Pay Period ${status}`);
			});
	};
};

const reviewPayPeriod = ({ id, action, payslips, note }) => {
	return (dispatch, getState) => {
		settingsRequest({
			method: "POST",
			path: `/payPeriods/${id}/review`,
			body: {
				action,
				payslips,
				note,
			},
		})
			.then(({ data }) => {
				dispatch(loadPayPeriod(data));
			})
			.catch((err) => {
				console.log("error", err);
				NotificationManager.error("Error Reviewing Pay Period", "Review Pay Period");
			});
	};
};

const payrollGetPayPeriod = ({ paySchedule, year, periodNo, navigate }) => {
	return (dispatch, getState) => {
		dispatch(updatingPayPeriod());

		let qs = "";

		if (periodNo) {
			qs = new URLSearchParams({
				periodNo,
				year,
				periods: paySchedule,
			}).toString();
		} else if (paySchedule) {
			qs = new URLSearchParams({
				periods: paySchedule,
			}).toString();
		}

		fetch(apiURL + `/settings/payPeriod?${qs}`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(getPayPeriod(data));
				if (navigate) navigate(`/organisation/payroll/${data.payPeriodDetails.id}`);
			});
	};
};

const payrollUpdatePayPeriod = (data) => {
	return (dispatch, getState) => {
		const state = getState();
		dispatch(updatingPayPeriod());

		settingsRequest({
			method: "POST",
			path: "/payPeriod",
			body: {
				...data,
				id: state.payroll.payPeriodDetails.id,
			},
		}).then(({ data }) => {
			dispatch(getPayPeriod(data));
		});
	};
};

const payrollSavedAllPayslips = (department) => ({
	type: Types.PAYROLL_SAVED_ALL_PAYSLIP,
	department,
});

const loadPayPeriod = (payPeriod) => ({
	type: Types.PAYROLL_PAY_PERIOD,
	payload: { payPeriodDetails: payPeriod },
});

const payrollUpdateId = (payPeriodId) => {
	return (dispatch, getState) => {
		const state = getState();
		const payPeriod = state.payPeriods?.periods?.find((p) => p.id == payPeriodId);

		dispatch(loadPayPeriod(payPeriod));
	};
};

const payrollGettingList = (payrunID) => ({
	type: Types.PAYROLL_GETTING_LIST,
	payrunID,
});

const payrollGetList = (payrunID) => {
	return (dispatch, getState) => {
		const state = getState();

		dispatch(payrollGettingList(payrunID));
		// console.log('payrollGetList',payrollGetList)

		fetch(apiURL + `/settings/payroll/${payrunID}`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then(async (data) => {
				console.log("payrollGetList entity data", data);
				if (state.payroll.payrunLoading == data?.payPeriodDetails?.id) {
					if (typeof data.employees == "string") {
						// this is a url from S3 get the data and insert inside the data object
						const employeeObject = await fetch(data.employees).then((response) => response.json());

						data.employees = employeeObject;
					}

					dispatch(payrollUpdateList(data));
					dispatch(payrollGettingList(null));
				}
			});
	};
};

const reopenPayPeriod = (id) => {
	return (dispatch, getState) => {
		const state = getState();

		fetch(apiURL + `/settings/reopenPayPeriod`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify({ id }),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				console.log("entity data", data);
				const payPeriodDetails = state.payroll.payPeriodDetails;
				const { paySchedule, year, period: periodNo } = payPeriodDetails;
				dispatch(payrollGetPayPeriod({ paySchedule, year, periodNo }));
			});
	};
};

const updateChecklistToggles = (key) => ({
	type: Types.PAYROLL_UPDATE_CHECKLIST_TOGGLE,
	key,
});

const updatePayrollChecklistPromise = pDebounce((periodId, body) => {
	return new Promise(async (resolve, reject) => {
		const response = await settingsRequest({
			path: `/payPeriod/${periodId}/checklist`,
			method: "POST",
			body,
		});
		resolve(response);
	});
}, 1000);

const updatePayrollChecklist = () => {
	return (dispatch, getState) => {
		const state = getState();
		const body = state.payroll?.payPeriodDetails?.checklist;
		const periodId = state.payroll?.payPeriodDetails?.id;

		updatePayrollChecklistPromise(periodId, body)
			.then(({ data }) => {
				dispatch(loadPayPeriod(data));
			})
			.catch((error) => {
				console.error(error);
				NotificationManager.error("Error Updating Payroll Data Checklist", "Payroll Data Checklist");
			});
	};
};

// Changes XML to JSON
const xmlToJson = (xml) => {
	// Create the return object
	var obj = {};

	if (xml.nodeType == 1) {
		// element
		// do attributes
		if (xml.attributes.length > 0) {
			obj["@attributes"] = {};
			for (var j = 0; j < xml.attributes.length; j++) {
				var attribute = xml.attributes.item(j);
				obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
			}
		}
	} else if (xml.nodeType == 3) {
		// text
		obj = xml.nodeValue;
	}

	// do children
	if (xml.hasChildNodes()) {
		for (var i = 0; i < xml.childNodes.length; i++) {
			var item = xml.childNodes.item(i);
			var nodeName = item.nodeName;
			if (typeof obj[nodeName] == "undefined") {
				obj[nodeName] = xmlToJson(item);
			} else {
				if (typeof obj[nodeName].push == "undefined") {
					var old = obj[nodeName];
					obj[nodeName] = [];
					obj[nodeName].push(old);
				}
				obj[nodeName].push(xmlToJson(item));
			}
		}
	}
	return obj;
};

const toggleTaxableWeek = ({ week, employeeID }) => ({
	type: Types.PAYROLL_TOGGLE_TAXABLE_WEEK,
	week,
	employeeID,
});

const showClearPayslipModal = (employee) => ({
	type: Types.PAYROLL_CLEAR_PAYSLIP_MODAL,
	employee,
});

const showResetPeriodStartModal = (date) => ({
	type: Types.PAYROLL_CHANGE_PERIOD_START,
	date,
});

const changePeriodStart = (date) => {
	return (dispatch, getState) => {
		const state = getState();
		dispatch(updatingPayPeriod());
		const { payDay, periodEnd, leaveCutOff, overtimeCutOff } = { ...state.payroll?.payPeriodDetails };

		fetch(apiURL + `/settings/payPeriod`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify({
				periodStart: date,
				payDay,
				periodEnd,
				leaveCutOff,
				overtimeCutOff,
				id: state.payroll.payPeriodDetails.id,
			}),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(getPayPeriod(data));
				dispatch(showResetPeriodStartModal());
			});
	};
};

const payslipClearing = (employeeID) => ({
	type: Types.PAYROLL_CLEARING_PAYSLIP,
	employeeID,
});

const payslipCleared = (employeeID) => ({
	type: Types.PAYROLL_CLEARED_PAYSLIP,
	employeeID,
});

const clearPayslip = (employee) => async (dispatch, getState) => {
	return new Promise((resolve, reject) => {
		dispatch(payslipClearing(employee.id));

		const data = {
			id: employee.payslipId,
		};

		fetch(apiURL + `/payroll/clear`, {
			credentials: "include",
			method: "POST",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
			body: JSON.stringify(data),
		})
			.then((response) => response.json())
			.then((data) => {
				dispatch(payrollSavePayslip(data, false, employee.id));
				dispatch(payslipCleared(employee.id));

				resolve();
			})
			.catch((err) => {
				console.log("error with payslip???", employee.id);
				dispatch(payrollErrorPayslip(employee.id));
				reject(err);
			});
	});
};

const savePayslip = ({ allowances, employee, ready, dispatch, country, payPeriodDetails, saveOnly }) => {
	return new Promise((resolve, reject) => {
		dispatch(payrollGeneratingPayslip(employee.id));

		const data = {
			allowances,
			id: employee.payslipId,
			ready,
			saveOnly,
			agreementId: employee.id,
			payPeriodId: payPeriodDetails.id,
			taxableWeeks: _.uniq(employee.taxableWeeks),
		};

		console.log("employeeTOFIND", employee);
		if (employee.note || employee?.payslip?.note) {
			data.note = employee.note ?? employee?.payslip?.note;
		}

		if (employee.toAdvisor || employee?.payslip?.toAdvisor) {
			data.toAdvisor = employee.toAdvisor ?? employee?.payslip?.toAdvisor;
		}

		const path = `/payroll/${country}`;
		// const path = `/payroll/uk`

		settingsRequest({
			method: "POST",
			path,
			body: data,
		})
			.then(({ data }) => {
				console.log("data", data);
				// const parser = new DOMParser();
				// const xmlDoc = parser.parseFromString(text,"text/xml");
				// const data = xmlToJson(xmlDoc).data

				// console.log('TEST!!!!',data[1].events['save-payslip-allowance'],ready,data[1].events['save-payslip-allowance']['entry'])

				if (data.id) {
					// console.log('TEST!!!!entity data',data[1].events['save-payslip-allowance'])
					dispatch(payrollSavePayslip(data, ready, employee.id));
				} else {
					dispatch(payrollErrorPayslip(employee.id));
				}
				resolve();
			})
			.catch((err) => {
				console.log("error with payslip???", employee.id);
				dispatch(payrollErrorPayslip(employee.id));
				reject(err);
			});
	});
};

const payrollSaveAll = (department) => async (dispatch, getState) => {
	const state = getState();

	let defaultHours = state.payroll.payPeriodDetails.defaultHours;
	const payPeriodDetails = state.payroll.payPeriodDetails;

	dispatch(payrollSavingAllPayslips(department));
	const notReady =
		state.payroll &&
		state.payroll.employees &&
		state.payroll.employees.filter(
			(employee) =>
				employee.employmentTypeName !== "External Contractor" &&
				!(
					employee.payslip?.ready &&
					(employee.payslip?.ready === true || employee.payslip?.ready?.toLowerCase() == "yes")
				) &&
				(!department || employee.department == department) &&
				employee.salaries.find(
					(s) =>
						!s.paySchedule ||
						(payPeriodDetails &&
							(s.paySchedule == payPeriodDetails.payPeriods ||
								s.paySchedule == payPeriodDetails.paySchedule)),
				),
		);

	console.log("notReady", notReady);

	const chunkedNotReady = _.chunk(notReady, 20);
	let alwaysExactHours =
		state.payroll.settings &&
		state.payroll.settings.alwaysExactHours &&
		state.payroll.settings.alwaysExactHours == "yes";

	const allowanceList = state.allowances.allowanceList;

	for (var i = chunkedNotReady.length - 1; i >= 0; i--) {
		await Promise.all(
			chunkedNotReady[i].map(async (employee) => {
				const allowances =
					(employee.allowances &&
						employee.allowances.filter(({ updated, allowanceType }) => updated && allowanceType)) ||
					[];

				allowances.map((a) => {
					if (isNaN(a.amount)) {
						a.amount = 0;
					}
					if (isNaN(a.input)) {
						a.input = 0;
					}
				});

				const { salaries } = employee;

				salaries.map((salary) => {
					const weeklyHours = parseFloat(salary.weeklyHours);

					const { start: engagementDate, end: terminationDate } = salary;

					console.log("engagementDate", engagementDate);

					const terminated =
						terminationDate &&
						terminationDate != engagementDate &&
						terminationDate <= payPeriodDetails.periodEnd;
					const engaged = engagementDate && engagementDate >= payPeriodDetails.periodStart;

					const salaryAllowances =
						salary.salaryAllowances &&
						salary.salaryAllowances.map((salaryAllowance) => {
							const exists =
								employee &&
								employee.allowances &&
								_.find(employee.allowances, {
									allowanceType: salaryAllowance.allowanceType || salaryAllowance.type,
									salary: salary.id, // TO be added as optional??
								});

							if (exists) {
								console.log("exists.payslipTOSEND", exists);
								return false;
							}

							const allowanceDetails = _.find(allowanceList, {
								id: salaryAllowance.allowanceType || salaryAllowance.type,
							});

							console.log("allowanceDetails", allowanceDetails);

							if (
								[
									"Cash",
									"Car Allowance",
									"Other",
									"Car FBV",
									"Deduction",
									"VOPS Employee",
									"VOPS Employer",
									"Director's Fees",
								].includes(allowanceDetails.method)
							) {
								// console.log('employee.payslipTOSEND1',employee.payslip,engaged,terminated,employee.payslip.processedTimesheets)

								// get hours ratio?
								const basicHourAllowance = _.find(employee.allowances, {
									allowanceType: 277,
									salary: salary.id, // TO be added as optional??
								});

								const unpaidHourAllowance = _.find(employee.allowances, {
									allowanceType: 6558,
									salary: salary.id, // TO be added as optional??
								});

								const basicHours = basicHourAllowance && basicHourAllowance.input;
								const unpaidHours = (unpaidHourAllowance && unpaidHourAllowance.input) || 0;

								let ratio = 1;
								if (
									salaryAllowance.salaryAllowanceFixed == "yes" ||
									allowanceDetails.salaryAllowanceFixed ||
									(alwaysExactHours && !terminated)
								) {
									// if fixed ratio should remain at 1 so do nothing
								} else if (basicHours || unpaidHours) {
									const defaultHoursThisEmployee = weeklyHours
										? (defaultHours / 40) * weeklyHours
										: defaultHours;
									ratio =
										((basicHours || defaultHoursThisEmployee) - unpaidHours) /
										defaultHoursThisEmployee;
								} else if (
									employee.payslip &&
									employee.payslip.processedTimesheets &&
									(terminated || engaged)
								) {
									// processed timesheets
									ratio = 0;
								}

								if (ratio < 0.0001 && ratio > 0) {
									// this needs to be 0 to eliminate rounding issues
									ratio = 0;
								}
								// console.log('employee.payslipTOSEND2',ratio,employee.payslip,engaged,terminated,employee.payslip.processedTimesheets)

								const salaryAllowanceAmount =
									salaryAllowance.salaryAllowanceAmount || salaryAllowance.amount;
								const newAllowance = {
									id: uuidv4(),
									allowanceType: salaryAllowance.allowanceType || salaryAllowance.type,
									amount: (salaryAllowanceAmount * ratio).toFixed(2),
									input: (salaryAllowanceAmount * ratio).toFixed(2),
									calculation: `${salaryAllowanceAmount} * ${ratio}`,
									name: allowanceDetails.allowanceName,
									employeeID: employee.id,
									salary: salary.id,
									linked: true,
									salaryAllowance: `${salary.id}.${salaryAllowance.type}`,
									// salaryAllowance:
								};
								console.log("allowanceDetails newAllowance", newAllowance);
								dispatch(
									payrollUpdateAllowance({
										...newAllowance,
										isNew: true,
									}),
								);
								allowances.push(newAllowance);
							}
						});

					console.log("allowancesToUpdate salaryAllowances", salaryAllowances);
				});

				employee.allowances &&
					employee.allowances.filter(({ updated, ...rest }) => {
						console.log("allowancesToUpdate rest", rest);
					});

				try {
					await savePayslip({
						employee,
						ready: true,
						allowances,
						dispatch,
						country: state.company?.settings?.jurisdiction?.toLowerCase() || "mt",
						payPeriodDetails: state.payroll.payPeriodDetails,
					});
				} catch (e) {
					console.log("payslipError", e);
				}
			}),
		);
	}

	dispatch(payrollSavedAllPayslips(department));
};

const payrollSaveAllowances = (employeeID, ready, saveOnly) => {
	return async (dispatch, getState) => {
		console.log("payrollSaveAllowances");

		const state = getState();

		let alwaysExactHours =
			state.payroll.settings &&
			state.payroll.settings.alwaysExactHours &&
			state.payroll.settings.alwaysExactHours == "yes";
		let defaultHours = state.payroll.payPeriodDetails.defaultHours;
		let payPeriodDetails = state.payroll.payPeriodDetails;

		const allowanceList = state.allowances.allowanceList;
		const employee = state.payroll.employees.find(({ id }) => id == employeeID);

		const newAllowances = [];

		const { salaries } = employee;

		salaries.map((salary) => {
			const weeklyHours = parseFloat(salary.weeklyHours);

			const { engagementDate, terminationDate } = employee;

			const terminated =
				terminationDate && terminationDate != engagementDate && terminationDate <= payPeriodDetails.periodEnd;
			const engaged = engagementDate && engagementDate >= payPeriodDetails.periodStart;
			const terminatedBeforeThisPay =
				terminationDate && terminationDate != engagementDate && terminationDate <= payPeriodDetails.periodStart;

			const salaryAllowances =
				salary.salaryAllowances &&
				salary.salaryAllowances.map((salaryAllowance) => {
					const exists =
						employee &&
						employee.allowances &&
						employee.allowances.find(
							(allowance) =>
								(allowance.allowanceType == salaryAllowance.allowanceType || salaryAllowance.type) &&
								(!allowance.salary || allowance.salary == salary.id), // TO be added as optional??
						);
					// _.find(employee.allowances,{
					//           allowanceType: salaryAllowance.allowanceType || salaryAllowance.type,
					//           salary: salary.id // TO be added as optional??
					//         })

					const allowanceDetails = _.find(allowanceList, {
						id: salaryAllowance.allowanceType || salaryAllowance.type,
					});

					if (
						allowanceDetails &&
						[
							"Cash",
							"Car Allowance",
							"Other",
							"Car FBV",
							"Deduction",
							"VOPS Employee",
							"VOPS Employer",
							"Director's Fees",
						].includes(allowanceDetails.method)
					) {
						// get hours ratio?
						const basicHourAllowance =
							employee.allowances &&
							employee.allowances.find(
								(e) => e.allowanceType == 277 && (!e.salary || e.salary == salary.id),
							);
						//   allowanceType: 277,
						//   salary: salary.id // TO be added as optional??
						// });

						const unpaidHourAllowance = _.find(
							employee.allowances,
							(e) => e.allowanceType == 6558 && (!e.salary || e.salary == salary.id),
						);
						// const unpaidHourAllowance = _.find(employee.allowances,{
						//                         allowanceType: 6558,
						//                         salary: salary.id // TO be added as optional??
						//                       });

						const basicHours = basicHourAllowance && basicHourAllowance.input;
						const unpaidHours = (unpaidHourAllowance && unpaidHourAllowance.input) || 0;

						let ratio = 1;
						console.log("salaryAllowance.salaryAllowanceFixed", salaryAllowance.salaryAllowanceFixed);
						if (
							salaryAllowance.salaryAllowanceFixed == "yes" ||
							allowanceDetails.salaryAllowanceFixed ||
							(alwaysExactHours && !terminated)
						) {
							// if fixed ratio should remain at 1 so do nothing
						} else if (basicHours || unpaidHours) {
							const defaultHoursThisEmployee = weeklyHours
								? (defaultHours / 40) * weeklyHours
								: defaultHours;
							ratio = ((basicHours || defaultHoursThisEmployee) - unpaidHours) / defaultHoursThisEmployee;
						} else if (
							employee.payslip &&
							employee.payslip.processedTimesheets &&
							(terminated || engaged)
						) {
							// processed timesheets
							ratio = 0;
						}

						if (ratio < 0.0001 && ratio > 0) {
							// this needs to be 0 to eliminate rounding issues
							ratio = 0;
						}
						// console.log('employee.payslip.processedTimesheets',employee.payslip.processedTimesheets)

						// if (salaryAllowance.allowanceType || salaryAllowance.type == 704379 && salaryAllowance.salaryAllowance == 1250078){
						// console.log('STOPPPP',basicHours,unpaidHours,defaultHours,ratio)
						// }

						const salaryAllowanceAmount = salaryAllowance.salaryAllowanceAmount || salaryAllowance.amount;
						if (exists) {
							console.log("AllowanceExists", exists, ratio);

							if (exists.linked && (salaryAllowance.salaryAllowanceAmount || salaryAllowance.amount)) {
								dispatch(
									payrollUpdateAllowance({
										...exists,
										amount: (salaryAllowanceAmount * ratio).toFixed(2),
										input: (salaryAllowanceAmount * ratio).toFixed(2),
										calculation: `${salaryAllowanceAmount} * ${ratio}`,
										employeeID: employeeID,
										// salary: salary.id,
										// salaryAllowance: `${salary.id}.${salaryAllowance.type}`,
										updated: true,
									}),
								);
							}

							return false;
						} else {
							if (!terminatedBeforeThisPay) {
								// add allowances if not terminated before now hence basic should be 0
								const newAllowance = {
									id: uuidv4(),
									allowanceType: salaryAllowance.allowanceType || salaryAllowance.type,
									linked: true,
									amount: (salaryAllowanceAmount * ratio).toFixed(2),
									input: (salaryAllowanceAmount * ratio).toFixed(2),
									calculation: `${salaryAllowanceAmount} * ${ratio}`,
									name: allowanceDetails.allowanceName,
									employeeID: employeeID,
									salary: salary.id,
									salaryAllowance: `${salary.id}.${salaryAllowance.type}`,
									// salaryAllowance:
								};
								console.log("allowanceDetails newAllowance", newAllowance);
								dispatch(
									payrollUpdateAllowance({
										...newAllowance,
										isNew: true,
									}),
								);
								newAllowances.push(newAllowance);
							}
						}
					}
				});
		});

		const refreshedState = getState();

		const refreshedEmployee = refreshedState.payroll.employees.find(({ id }) => id == employeeID);

		const allowances =
			(refreshedEmployee.allowances &&
				refreshedEmployee.allowances.filter(({ updated, allowanceType }) => updated && allowanceType)) ||
			[];

		allowances.map((a) => {
			if (isNaN(a?.amount)) {
				a.amount = 0;
			}
			if (isNaN(a?.input)) {
				a.input = 0;
			}
		});

		console.log("allowancesToSave", allowances, newAllowances);

		await savePayslip({
			employee,
			allowances: allowances, //[...allowances,...newAllowances],
			ready,
			saveOnly,
			dispatch,
			country: state.company?.settings?.jurisdiction?.toLowerCase() || "mt",
			payPeriodDetails: state.payroll.payPeriodDetails,
		});
	};
};

const generatingPayrollReports = (status, id) => ({
	type: Types.PAYROLL_GENERATING_REPORTS,
	status,
	id,
});

const payslipPreviewGenerating = (id, status) => ({
	type: Types.PAYROLL_PREVIEW_PAYSLIP,
	status,
});

const getPayrollStepFunctionState = ({ arn, name, id }) => {
	return (dispatch, getState) => {
		const state = getState();

		if (!arn) {
			NotificationManager.error("Missing ARN for Get Payroll Report", "Error");
			dispatch(generatingPayrollReports(false, id));
			return;
		}

		const path = `/pdf/report-status/${arn}`;

		fetch(apiURL + path, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				console.log("entity data", data);

				const finished = data?.data && data?.data?.status != "RUNNING";

				if (finished) {
					if (data.data.status == "SUCCEEDED") {
						if (name == "concludePayroll") {
							NotificationManager.success(`Your payroll reports are ready`, "Success");

							dispatch(generatingPayrollReports(false, id));
							dispatch(getPayPeriodDetails(id));
						}

						if (name == "previewPayslip") {
							console.log("payslipReady", data);
							// open new tab with payslip
							dispatch(payslipPreviewGenerating(id, false));

							const responseData = JSON.parse(data.data.output);

							if (responseData.url) {
								const popup = window.open(responseData.url);
								if (!popup || popup.closed || typeof popup.closed == "undefined") {
									//Worked For IE and Firefox
									alert("Popup Blocker is enabled! Please add this site to your exception list.");
								}
							}
						}
					} else {
						NotificationManager.error(`There was a problem creating your reports`, "Error");
						if (name == "concludePayroll") {
							dispatch(generatingPayrollReports(false, id));
							dispatch(getPayPeriodDetails(id));
						}
					}
				} else {
					setTimeout(() => {
						dispatch(getPayrollStepFunctionState({ arn, name, id }));
					}, 1000);
				}
			});
	};
};

const previewPayslip = (payslipId) => {
	return (dispatch, getState) => {
		const state = getState();

		// dispatch(generatingPayrollReports(true));
		fetch(apiURL + `/settings/payslip/${payslipId}/preview`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				// 'Content-Type': 'application/x-www-form-urlencoded',
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				// TODO add notification
				console.log("payslip preview", data);

				const arn = data.executionArn;
				// dispatch(getLeaveBalance())

				setTimeout(() => {
					dispatch(getPayrollStepFunctionState({ arn, name: "previewPayslip", id: payslipId }));
				}, 1000);
			});

		dispatch(payslipPreviewGenerating(payslipId, true));
	};
};

const concludePayroll = ({ id }) => {
	return (dispatch, getState) => {
		const state = getState();

		const period = state.payroll?.payPeriodDetails?.id;

		dispatch(generatingPayrollReports(true, id));
		settingsRequest({
			path: `/payroll/complete/${id || period}`,
			method: "GET",
		}).then(({ data }) => {
			console.log("we are creating the payslips and FS documents");
			const arn = data?.data?.executionArn;
			// dispatch(getLeaveBalance())

			if (data.error == "Insufficient Credits") {
				NotificationManager.error("Insufficient Credits Available. Purchase credits to continue.", "Error");
			} else if (!data?.data?.error) {
				setTimeout(() => {
					dispatch(getPayrollStepFunctionState({ arn, name: "concludePayroll", id }));
				}, 1000);
			} else {
				NotificationManager.error(data?.data?.error, "Error");
			}
		});
	};
};

/**
 * @param {*} bank
 * @param {*} fileType
 * @param {*} params { period: payPeriodId, executionDate: transferDate }
 * @param {*} params APS params: { period: payPeriodId, executionDate: transferDate, custCode, fileRef }
 * @returns
 */
const downloadSepaFile = (bank, fileType, params) => {
	return (dispatch, getState) => {
		// window.open(`${apiURL}/sepa/${bank}?period=${payPeriodId}&executionDate=${transferDate}`, "_blank")

		const state = getState();
		const jurisdiction = state.company?.settings?.jurisdiction;

		if (fileType === "TXT" && jurisdiction === "UK") {
			settingsRequest({
				method: "GET",
				path: `/payment/BACS`,
				query: params,
			})
				.then(({ data }) => {
					if (data.signedURL) {
						const popup = window.open(data.signedURL);
						if (!popup || popup.closed || typeof popup.closed == "undefined") {
							//Worked For IE and Firefox
							alert("Popup Blocker is enabled! Please add this site to your exception list.");
						}
					}
				})
				.catch((error) => {
					console.error(error);
					NotificationManager.error("Error Generating BACS File", "BACS File");
				});
		} else {
			sepaRequest({
				method: "GET",
				path: `/${bank}`,
				query: params,
				responseType: "blob",
			})
				.then(({ data }) => {
					if (data.signedURL) {
						const popup = window.open(data.signedURL);
						if (!popup || popup.closed || typeof popup.closed == "undefined") {
							//Worked For IE and Firefox
							alert("Popup Blocker is enabled! Please add this site to your exception list.");
						}
					}
				})
				.catch((error) => {
					console.error(error);
					NotificationManager.error("Error Generating BACS File", "BACS File");
				});
		}
	};
};

const downloadProcessTimesheetReport = (reportType, payPeriodId) => {
	return (dispatch, getState) => {
		const state = getState();

		const payPeriodDetails = state.payroll && state.payroll.payPeriodDetails;
		// const moment = window.moment;
		// const $ = window.$;

		let startDate = payPeriodDetails.periodStart; // moment($('#pay-period .start-date').val(), 'DD MMM YYYY').format("YYYY-MM-DD");
		let endDate = payPeriodDetails.periodEnd;

		if (payPeriodDetails?.overtimeCutOff && payPeriodDetails.overtimeCutOff != payPeriodDetails.periodEnd) {
			endDate = payPeriodDetails.overtimeCutOff;
		}

		const previousPeriodEnd = format(addDays(new Date(startDate), -1), "yyyy-MM-dd");
		if (payPeriodDetails?.previousOvertimeCutOff && payPeriodDetails.previousOvertimeCutOff != previousPeriodEnd) {
			// start = 1 day after previous end
			startDate = format(addDays(new Date(payPeriodDetails.previousOvertimeCutOff), 1), "yyyy-MM-dd");
		}

		const department = state.payroll.processTimesheetDepartment;

		fetch(apiURL + `/settings/process-timesheets-report/${startDate}/${endDate}`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify({
				companyPayPeriod: payPeriodDetails.id,
				leaveCutOff: payPeriodDetails.leaveCutOff,
				department,
			}),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.signedURL) {
					const popup = window.open(data.signedURL);
					if (!popup || popup.closed || typeof popup.closed == "undefined") {
						//Worked For IE and Firefox
						alert("Popup Blocker is enabled! Please add this site to your exception list.");
					}
				} else {
					console.log("data", data);
				}
			});
	};
};

const downloadReport = (reportType, payPeriodId) => {
	return (dispatch, getState) => {
		settingsRequest({
			method: "GET",
			path: `/report/${reportType}/${payPeriodId}`,
		}).then(({ data }) => {
			if (data.signedURL) {
				const popup = window.open(data.signedURL);
				if (!popup || popup.closed || typeof popup.closed == "undefined") {
					//Worked For IE and Firefox
					alert("Popup Blocker is enabled! Please add this site to your exception list.");
				}
			} else if (data.error) {
				let message = data.error;
				if (data.error == "Not found") {
					message =
						"A presaved copy of this report is not available. Some reports such as bank files are only generated and saved through the payroll view.";
				}
				NotificationManager.error(message, "Error");
				console.log("dataError", data.error);
			}
		});
	};
};

const downloadAllPayslips = (payPeriodId) => {
	return (dispatch, getState) => {
		fetch(apiURL + `/settings/payslips/payPeriod/${payPeriodId}`, {
			credentials: "include",
			method: "GET",
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		})
			.then((response) => response.json())
			.then((data) => {
				if (data.signedURL) {
					const popup = window.open(data.signedURL);
					if (!popup || popup.closed || typeof popup.closed == "undefined") {
						//Worked For IE and Firefox
						alert("Popup Blocker is enabled! Please add this site to your exception list.");
					}
				} else {
					console.log("data", data);
				}
			});
	};
};

const payTerminatedEmployeeModal = (show) => ({
	type: Types.PAYROLL_PAY_TERMINATED_MODAL,
	show,
});

const terminatedEmployeePayslipLoading = () => ({
	type: Types.PAYROLL_PAY_TERMINATED_LOADING,
});

const terminatedEmployeePayslipCreated = () => ({
	type: Types.PAYROLL_CREATE_TERMINATED_PAYSLIP,
});

const addPayslipForTerminatedEmployee = (employeeID) => {
	return async (dispatch, getState) => {
		dispatch(terminatedEmployeePayslipLoading());

		const state = getState();

		const employee = state.employees.employeeListWithSalary.find(({ id }) => id == employeeID);
		// const employee = state.employees.terminatedEmployees.find(({id}) => id == employeeID)

		await savePayslip({
			employee,
			read: false,
			dispatch,
			country: state.company?.settings?.jurisdiction?.toLowerCase() || "mt",
			payPeriodDetails: state.payroll.payPeriodDetails,
		});

		dispatch(terminatedEmployeePayslipCreated());

		// trigger get list as employee list changed due to new employee
		dispatch(payrollGetList(state.payroll.payPeriodDetails.id));
	};
};

const unprocessTimesheetsModal = (agreementID) => ({
	type: Types.PAYROLL_UNPROCESS_TIMESHEETS_MODAL,
	agreementID,
});

const unprocessTimesheetsLoading = () => ({
	type: Types.PAYROLL_UNPROCESS_LOADING,
});

const unprocessTimesheetsCompleted = (payload) => ({
	type: Types.PAYROLL_UNPROCESS_COMPLETED,
	payload,
});

const unprocessTimesheets = () => {
	return (dispatch, getState) => {
		dispatch(unprocessTimesheetsLoading());

		const state = getState();

		const agreementID = state.payroll.unprocessPayslipModal;
		const employee = agreementID && _.find(state.payroll.employees, { id: agreementID });

		const data = {
			companyPayPeriod: state.payroll.payPeriodDetails.id,
			agreement: agreementID,
			payslip: employee.payslip.id,
		};

		fetch(apiURL + `/settings/timesheets/unprocess`, {
			credentials: "include",
			method: "POST",
			body: JSON.stringify(data),
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
				/*'Organisation': getState().currentOrganisation,*/
			},
		})
			.then((response) => response.json())
			.then((data) => {
				console.log("last pay period", data);
				dispatch(unprocessTimesheetsCompleted(data));
			});
	};
};

const clearProcessTimesheets = () => ({
	type: Types.PAYROLL_PROCESS_TIMESHEETS_CLEAR,
});

const processTimesheetsStart = (simulate, department) => ({
	type: Types.PAYROLL_PROCESS_TIMESHEETS_START,
	simulate,
	department,
});

const processTimesheetsCompleted = (payload) => ({
	type: Types.PAYROLL_PROCESS_TIMESHEETS_COMPLETE,
	payload,
});

const processTimesheets = (simulate, department) => {
	return (dispatch, getState) => {
		console.log("testState", simulate, department);
		const state = getState();

		if (!department && !simulate) {
			department = state.payroll.processTimesheetDepartment;
			console.log("getDeptFromState", department, state.payroll.processTimesheetDepartment);
		}

		dispatch(processTimesheetsStart(simulate, department));

		const payPeriodDetails = state.payroll && state.payroll.payPeriodDetails;
		// const moment = window.moment;
		// const $ = window.$;

		if (simulate) {
			dispatch(LEAVEACTIONS.leaveGetBalances(payPeriodDetails.periodEnd, department));
		}

		let startDate = payPeriodDetails.periodStart; // moment($('#pay-period .start-date').val(), 'DD MMM YYYY').format("YYYY-MM-DD");
		let endDate = payPeriodDetails.periodEnd; // moment($('#pay-period .end-date').val(), 'DD MMM YYYY').format("YYYY-MM-DD");

		const periodStartDate = startDate;
		const periodEndDate = endDate;

		if (payPeriodDetails?.overtimeCutOff && payPeriodDetails.overtimeCutOff != payPeriodDetails.periodEnd) {
			endDate = payPeriodDetails.overtimeCutOff;
		}

		const previousPeriodEnd = format(addDays(new Date(startDate), -1), "yyyy-MM-dd");
		if (payPeriodDetails?.previousOvertimeCutOff && payPeriodDetails.previousOvertimeCutOff != previousPeriodEnd) {
			// start = 1 day after previous end
			startDate = format(addDays(new Date(payPeriodDetails.previousOvertimeCutOff), 1), "yyyy-MM-dd");
		}

		// this is the old way we used to do this with casual dates
		// if ($('#casual-start-date').length > 0){
		//   startDate =  payPeriodDetails.casualStartDate
		//   endDate = payPeriodDetails.casualEndDate
		// }

		let payDate = payPeriodDetails.payDay;

		const processOrSimulate = simulate ? "simulate" : "process";

		console.log("here#!@#!@#");

		// notification goes here
		if (processOrSimulate == "process") {
			// NotificationManager.success(`Processing timesheets into payroll. Wait until the page reloads.`,'Success')
		}
		// loader setting goes here

		settingsRequest({
			method: "POST",
			path: `/timesheets-${processOrSimulate}/${startDate}/${endDate}`,
			body: {
				companyPayPeriod: payPeriodDetails.id,
				periodStartDate,
				periodEndDate,
				previousLeaveCutOff: payPeriodDetails.previousLeaveCutOff,
				leaveCutOff: payPeriodDetails.leaveCutOff,
				previousOvertimeCutOff: payPeriodDetails.previousOvertimeCutOff,
				overtimeCutOff: payPeriodDetails.overtimeCutOff,
				casualStartDate: startDate,
				casualEndDate: endDate,
				payDate,
				department,
			},
			headers: {
				"Accept": "application/json",
				"Content-Type": "application/json",
			},
		}).then(({ data }) => {
			// console.log('data',data)
			dispatch(processTimesheetsCompleted(data.results));
			if (!simulate) {
				// we can fill this data dynamically can we? or just kick a data refresh without reload?

				// window.Buddy.processTimesheets(data)
				// if (window.location.pathname.includes('payroll-new')){
				window.location.reload();
				// } else {
				//   close()
				// }
			}
		});
	};
	// do work here
};

const RTISubmissionsGenerating = () => ({
	type: Types.PAYROLL_RTI_GENERATING,
});

const RTISubmissionsGenerated = (payload) => ({
	type: Types.PAYROLL_RTI_GENERATING,
	payload,
});

const generateRTISubmissions = (periodId) => {
	return (dispatch, getState) => {
		const state = getState();

		dispatch(RTISubmissionsGenerating());

		settingsRequest({
			method: "POST",
			path: `/submit/rti/FPS`,
			body: {
				payPeriodId: periodId || state.payroll.payPeriodDetails.id,
			},
		}).then(({ data }) => {
			checkExecutionStatus(data.data.executionArn)
				.then(({ output }) => {
					NotificationManager.success(`RTI has been submitted`, "Success");
					dispatch(RTISubmissionsGenerated(output));
				})
				.catch((error) => {
					console.error(error);
					NotificationManager.error(`There was an error submitting RTI`, "Error");
				});
		});
	};
};

const submitEPS = (taxForm) => {
	return async (dispatch, getState) => {
		const { id: taxFormId, org } = taxForm;

		await settingsRequest({
			method: "POST",
			path: `/submit/rti/EPS`,
			body: {
				formId: taxFormId,
			},
			org,
		}).then(async ({ data }) => {
			NotificationManager.info(`Submitting EPS...`, "Submit EPS");
			await checkExecutionStatus(data.data.executionArn)
				.then(({ output }) => {
					taxForm = output.data;
					NotificationManager.success(`EPS has been submitted successfully!`, "Submit EPS");
				})
				.catch(({ data }) => {
					taxForm = data?.cause?.data;
					NotificationManager.error(`There was an error submitting EPS`, "Submit EPS");
				});
		});

		if (taxForm) dispatch(FSSREPORT_ACTIONS.fssReportingUpdateSingle(taxForm));
	};
};

const setTestInLiveModal = (show) => ({
	type: Types.PAYROLL_TEST_IN_LIVE_MODAL,
	show,
});

const setTestConfirmationModal = (show) => ({
	type: Types.PAYROLL_TEST_CONFIRMATION_MODAL,
	show,
});

const clearPayrollState = () => ({
	type: Types.PAYROLL_CLEAR_STATE,
});

const showUnsavedChangesModal = (show) => ({
	type: Types.PAYROLL_UNSAVED_CHANGES_MODAL,
	show,
});

const setOpenApprovalModal = (status) => ({
	type: Types.PAYROLL_APPROVAL_OPEN_MODAL,
	status,
});

const setLateSubmitModal = (status) => ({
	type: Types.PAYROLL_SET_LATE_SUBMIT_MODAL,
	status,
});

const Actions = {
	clearPayrollState,
	toggleTaxableWeek,
	payrollGetList,
	payrollToggleEmployeeExpand,
	payrollUpdateAllowance,
	payrollRemoveAllowance,
	payrollSaveAllowances,
	payrollSaveAll,
	concludePayroll,
	payrollPageToggle,
	setPayrollDepartmentExpanded,
	payrollGetLastPayPeriod,
	processTimesheets,
	clearProcessTimesheets,
	unprocessTimesheetsModal,
	payrollUpdateId,
	unprocessTimesheets,
	reopenPayPeriod,
	payTerminatedEmployeeModal,
	addPayslipForTerminatedEmployee,
	payrollGetPayPeriod,
	setReopenPayrollModalOpen,
	payrollUpdatePayPeriod,
	downloadSepaFile,
	downloadAllPayslips,
	previewPayslip,
	downloadReport,
	showClearPayslipModal,
	clearPayslip,
	downloadProcessTimesheetReport,
	generateRTISubmissions,
	payrollUpdateNote,
	showResetPeriodStartModal,
	changePeriodStart,
	setTestInLiveModal,
	setTestConfirmationModal,
	showUnsavedChangesModal,
	toggleHolidayPayModal,
	getHolidayPay,
	uploadAllowanceModal,
	setOpenApprovalModal,
	getPayPeriodDetails,
	updatePayPeriodStatus,
	reviewPayPeriod,
	updateChecklistToggles,
	updatePayrollChecklist,
	submitEPS,
	setLateSubmitModal,
};

// exports = {
//   Types,
//   Actions
// }

export { Actions, Types };

// exports.Types = Types
// exports.Actions = Actions
